import styled from '@emotion/styled'

interface StyleGridItemsProps {
  cols?: number
  customStyle?: string
}

export const StyleGridItems = styled.div<StyleGridItemsProps>`
  display: grid;
  gap: 15px;
  grid-template-columns: ${(props) => `repeat(${props.cols ?? 4}, 1fr)`};

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
  }

  ${(props) => props.customStyle || ''}
`

export const StyleGridItem = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  padding: 15px 20px;
  box-shadow: 0px 0px 4px -1px rgba(0, 0, 0, 0.12);
  border-color: ${(props: any) =>
    props.theme.colors[props.bc || 'borderColor']};
  @media (max-width: 768px) {
    padding: 12px 16px;
  }

  @media (max-width: 480px) {
    padding: 10px 14px;
  }
`

export const StyleGridIconWrapper = styled.div<any>`
  background: ${(props: any) => props.theme.colors[props?.bg || 'primary50']};
  height: 50px;
  width: 50px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
  }

  @media (max-width: 480px) {
    height: 35px;
    width: 35px;
  }
`

export const StyleGridTitle = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.black500};

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`

export const StyleGridValue = styled.p<any>`
  font-size: ${(props) => props?.font ?? 16}px;
  color: ${(props: any) => props.theme.colors[props.tc || 'primaryText']};

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`

export const StyleGridRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 7px;
  width: 100%;

  @media (max-width: 768px) {
    margin-bottom: 5px;
  }

  @media (max-width: 480px) {
    margin-bottom: 4px;
  }
`
